<template>
  <div>
    <div class="content" style="width:auto">
      <div class="cont-list">
        <span class="list" v-show="editMode">
          {{ this.parentRoute.menuName }}-申请{{ typeName }}
        </span>
        <span class="list" v-show="!editMode">
          {{ this.parentRoute.menuName }}-{{ title }}申请{{ typeName }}
        </span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="isBack ? rules2 : rules1">
        <div class="edit-card">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">{{ typeName }}基础信息</span>
          </div>

          <el-row>
            <el-col :span="6">
              <el-form-item :label="typeName + '单号'" prop="no">
                <el-input disabled v-model="form.no" :placeholder="'系统自动生成' + typeName + '单号'" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="isBack">
              <el-form-item label="外调单号" prop="assetOutTransferNo">
                <el-select :disabled="!editMode" v-model="form.assetOutTransferNo" style="width: 90%" filterable placeholder="请选择外调单号" :filter-method="GetAssetOutTransfers" @change="AssetOutTransfersChange">
                  <el-option v-for="item in STATIC_AssetOutTransfers.data" :key="item.id" :label="item.no" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人" prop="createdUserName">
                <el-input v-model="form.createdUserName" disabled style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建日期" prop="createdTime">
                <el-date-picker disabled v-model="form.createdTime" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="系统默认为当前日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="原库房" prop="warehouseName">
                <el-select :disabled="!editMode || isBack" v-model="form.warehouseName" style="width: 90%" filterable placeholder="请选择接收库房" :filter-method="getWarehouses" @change="warehouseChange">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="库房管理员" prop="warehouseManagerName">
                <el-input disabled v-model="form.warehouseManagerName" placeholder="系统自动带出库房管理员" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="isBack">
              <el-form-item label="调回库房" prop="inWarehouseName">
                <el-select :disabled="!editMode" v-model="form.inWarehouseName" style="width: 90%" filterable placeholder="请选择库房" :filter-method="getWarehouses" @change="backWarehouseChange">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="isBack">
              <el-form-item label="库房管理员" prop="inWarehouseManagerName">
                <el-input disabled v-model="form.inWarehouseManagerName" placeholder="系统自动带出库房管理员" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="外调联系人" prop="contactor">
                <el-input :disabled="!editMode" v-model="form.contactor" placeholder="请填写外调联系人" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="联系方式" prop="phone">
                <el-input v-model="form.phone" :disabled="!editMode" style="width:90%" placeholder="请填写外调联系人联系方式"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="typeName + '日期'" prop="date">
                <el-date-picker :disabled="!editMode" v-model="form.date" style="width: 90%" type="date" value-format="yyyy-MM-dd" :placeholder="'请选择' + typeName + '日期'">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="总数量" prop="totalNumber">
                <el-input disabled v-model="form.totalNumber" placeholder="根据详细信息数量求和汇总" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="总金额" prop="totalAmount">
                <el-input-number disabled v-model="form.totalAmount" :min="0" :precision="4" :controls="false" placeholder="根据详细信息金额求和汇总" style="width:90%"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="typeName + '原因'" prop="reason">
                <el-input :disabled="!editMode" v-model="form.reason" :placeholder="'请填写' + typeName + '原因'" resize="none" type="textarea" :rows="5" style="width:95%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width:95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <AssetInfoEdit ref="AssetInfoEditRef" :details="form.details" :canEdit="editMode" :typeName="typeName" :ParentForm="form" :FixedAssetParam="{
            warehouseId: form.warehouseId,
            StocktakingCategory:1
          }" @autoTotalAmount="autoTotalAmount" @assetChange="assetChange" :getFixedAssetListMethod="getFixedAssetListMethod" :getAssetCardsMethod="getAssetCardsMethod" :isRepeatMethod="isRepeatMethod" :isRepeatMsg="`当前${typeName}信息已存在，请去子表编辑！`" :mustCard="true" />
        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import GetDataMixin from "@/mixin/getData-mixin.js";
import { MaintenanceDimensionOptions } from "@/enum";
import { validPhone } from "@/utils/validate";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import AssetInfoEdit from "@/components/asset-into-edit";
import {
  GetAssetOutTransferById,
  SaveAssetOutTransfer,
  RejectAssetOutTransfer,
  GetAssetInTransferById,
  SaveAssetInTransfer,
  RejectAssetInTransfer,
} from "@/api";
export default {
  mixins: [GetDataMixin],
  components: { SelectTable, ApproveInfo, AssetInfoEdit },
  /** 定义属性 */
  data () {
    var validatePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("联系方式不能为空"));
      } else {
        if (validPhone(value)) {
          callback();
        } else {
          callback(new Error("联系方式有误"));
        }
      }
    };
    return {
      editMode: false,
      showWorkFlowInfo: false,
      form: {},
      rules1: {
        warehouseName: [
          { required: true, message: "原库房不能为空", trigger: "blur" },
        ],
        contactor: [
          { required: true, message: "外调联系人不能为空", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "联系方式不能为空", trigger: "blur" },
        ],
        date: [
          { required: true, message: "外调日期不能为空", trigger: "blur" },
        ],
        reason: [
          { required: true, message: "外调原因不能为空", trigger: "blur" },
        ],
      },
      rules2: {
        outNo: [
          { required: true, message: "外调单号不能为空", trigger: "blur" },
        ],
        inWarehouseName: [
          { required: true, message: "调回库房不能为空", trigger: "blur" },
        ],
        contactor: [
          { required: true, message: "外调联系人不能为空", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "联系方式不能为空", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
        date: [
          { required: true, message: "调回日期不能为空", trigger: "blur" },
        ],
      },
      MaintenanceDimensionOptions: MaintenanceDimensionOptions,

      oldDeptUsers: [],
      newDeptUsers: [],
      reject: null,
      isBack: false,
      typeName: "外调",
      assetListOptions: [],
      assetCardInfos: [],
    };
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    InitData () {
      var query = this.$route.query;
      if (query.type) {
        this.isBack = query.type == "1";
      }
      this.reject = this.isBack
        ? RejectAssetInTransfer
        : RejectAssetOutTransfer;
      if (query.id) {
        this.handleUpdate(query.id);
      } else {
        this.handleAdd();
      }
      this.typeName = this.isBack ? "调回" : "外调";
      this.$route.meta.menuName = this.isBack ? "资产调回编辑" : "资产外调编辑";
      window.console.log(this.$route);
    },
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      if (this.isBack) {
        GetAssetInTransferById({ id }).then((res) => {
          // this.resetForm()
          this.form = res.returnData;

          if (!this.form.details) {
            this.form.details = [];
          }
          this.form.details.forEach((e, index) => {
            e.$index = index + 1;
          });

          this.$refs.AssetInfoEditRef.setDetalis(this.form.details);
          this.initWorkFlowProperty(this.form);
          this.form.details.forEach((e, index) => {
            e.$index = index + 1;
          });
        });
      } else {
        GetAssetOutTransferById({ id }).then((res) => {
          // this.resetForm()
          this.form = res.returnData;

          if (!this.form.details) {
            this.form.details = [];
          }
          this.form.details.forEach((e, index) => {
            e.$index = index + 1;
          });
          this.warehouseChange(this.form.warehouseId);
          this.$refs.AssetInfoEditRef.setDetalis(this.form.details);
          this.initWorkFlowProperty(this.form);
          this.form.details.forEach((e, index) => {
            e.$index = index + 1;
          });
        });
      }
    },
    /**
     * 初始化表单
     */
    resetForm () {
      if (this.isBack) {
        // 调回
        this.form = {
          createdUserName: this.userInfo.name,
          createdTime: this.parseTime(new Date(), "{y}-{m}-{d}"),
          date: this.parseTime(new Date(), "{y}-{m}-{d}"),
          warehouseId: null,
          warehouseName: null,
          warehouseManagerId: null,
          warehouseManagerName: null,
          inWarehouseId: null,
          inWarehouseName: null,
          inWarehouseManagerId: null,
          inWarehouseManagerName: null,
          contactor: null,
          phone: null,
          totalNumber: null,
          totalAmount: null,
          details: [],
          orgCode :sessionStorage.getItem('orgId')
        };
      } else {
        // 外调
        this.form = {
          createdUserName: this.userInfo.name,
          createdTime: this.parseTime(new Date(), "{y}-{m}-{d}"),
          date: this.parseTime(new Date(), "{y}-{m}-{d}"),
          warehouseId: null,
          warehouseName: null,
          warehouseManagerId: null,
          warehouseManagerName: null,
          contactor: null,
          phone: null,
          totalNumber: null,
          totalAmount: null,
          details: [],
          orgCode :sessionStorage.getItem('orgId')
        };
      }
    },
    // 保存
    submit () {
      this.form.details = this.$refs.AssetInfoEditRef.getDetails();
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        if (this.isBack) {
          SaveAssetInTransfer(this.form).then((res) => {
            this.$my_message(`执行成功`, "success");
            sessionStorage.setItem("editMode", 0);
            this.$router.push({ path: this.getMainPath(this.$route.path) });
          }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
        } else {
          SaveAssetOutTransfer(this.form).then((res) => {
            this.$my_message(`执行成功`, "success");
            sessionStorage.setItem("editMode", 0);
            this.$router.push({ path: this.getMainPath(this.$route.path) });
          }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
        }
      });
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },

    /**
     * 原库房选择
     */
    warehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.form.warehouseId = item.id;
        this.form.warehouseManagerId = item.managerId;
        this.form.warehouseManagerName = item.managerName;
      }
      window.setTimeout(() => {
        this.$refs.AssetInfoEditRef.getFixedAssetList("");
      }, 200);
    },
    /**
     * 外调单号选择
     */
    AssetOutTransfersChange (val) {
      let item = this.STATIC_AssetOutTransfers.data.find((e) => e.id == val);
      if (item) {
        this.form.inWarehouseId = item.id;
        this.form.warehouseId = item.warehouseId;
        this.form.warehouseName = item.warehouseName;
        this.form.warehouseManagerId = item.warehouseManagerId;
        this.form.warehouseManagerName = item.warehouseManagerName;
        this.form.contactor = item.contactor;
        this.form.phone = item.phone;

        this.form.inWarehouseId = item.warehouseId;
        this.form.inWarehouseName = item.warehouseName;
        this.form.inWarehouseManagerId = item.warehouseManagerId;
        this.form.inWarehouseManagerName = item.warehouseManagerName;

        let id = val;
        GetAssetOutTransferById({ id }).then((res) => {
          this.assetListOptions = res.returnData.details;
          this.$refs.AssetInfoEditRef.getFixedAssetList("");
        });
      }
    },
    /**
     * 调回库房选择
     */
    backWarehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.form.inWarehouseId = item.id;
        this.form.inWarehouseManagerId = item.managerId;
        this.form.inWarehouseManagerName = item.managerName;
      }
    },

    autoTotalAmount (e) {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details = e;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber;
      this.form.totalAmount = totalAmount;
    },
    /**
     * 明细表添加
     */
    handleAddChildForm () {
      if (!this.form.details) {
        this.form.details = [];
      }
      this.openSubformModal = true;
      this.resetDetailFormData();
    },
    /**
     * 获取资产信息
     */
    getFixedAssetListMethod (keyWord) {
      if (this.isBack) {
        return new Promise((resolve, reject) => {
          resolve(
            this.assetListOptions.filter(
              (t) => t.fixedAssetName.indexOf(keyWord) != -1
            )
          );
        });
      } else {
        return new Promise((resolve, reject) => {
          resolve(this.$refs.AssetInfoEditRef.getFixedAssetListSelf(""));
        });
      }
    },
    /**
     * 资产选择
     */
    assetChange (e) {
      this.assetCardInfos = e.assetCardInfos;
    },
    /**
     * 获取资产卡号
     */
    getAssetCardsMethod (keyWord) {
      if (this.isBack) {
        return new Promise((resolve, reject) => {
          resolve(this.assetCardInfos);
        });
      } else {
        return new Promise((resolve, reject) => {
          resolve(this.$refs.AssetInfoEditRef.getAssetCardsSelf(""));
        });
      }
    },
    isRepeatMethod (arr, row) {
      let item = arr.find(
        (e) =>
          e.$index != row.$index &&
          e.assetId == row.assetId &&
          e.price == row.price &&
          e.locationName == row.locationName &&
          e.assetSource == row.assetSource &&
          e.packDesc == row.packDesc &&
          e.manufacturerId == row.manufacturerId &&
          e.certId == row.certId &&
          e.brandId == row.brandId
      );
      if (item) {
        return true;
      } else {
        return false;
      }
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.getWarehouses();
    this.InitData();
  },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () {
    this.$refs.AssetInfoEditRef.getFixedAssetList("");
    this.$refs.AssetInfoEditRef.getAssetCards("");
    this.GetAssetOutTransfers();
  },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped></style>
